import EvaluationCategoryDto from "../../dto/EvaluationCategoryDto";

export default class EvaluationCategoryUpdateRequest {
  evaluationCategories = [];
  constructor(datas) {
    datas.forEach(data => {
      const evaluationCategoryDto = new EvaluationCategoryDto(data);
      this.evaluationCategories.push(evaluationCategoryDto);
    });
  }
}
